import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_c4edff = setTheme(({ theme }) => `background-color: ${theme.colors.color_c4edff}`);
